import storage from "@/_util/storage-methods"
import globalAppConfig from "@/app.config.global.js"
const transparent = {r:0,g:0,b:0,a:0};

export default [

    {
        name: "timeFormat",
        get: storage.getLocalStorage("user-time-format", "HH:mm:ss"),
        set: storage.setLocalStorage("user-time-format"),
    },
    {
        name: "dateFormat",
        get: storage.getLocalStorage("user-date-format", "ddd, MMM DD, YYYY"),
        set: storage.setLocalStorage("user-date-format"),
    },

    {
        name: "darkMode",
        get: storage.getLocalStorageBoolean("user-dark-mode", null),
        set: storage.setLocalStorage("user-dark-mode"),
    },
    {
        name: "topBarColor",
        get: storage.getLocalStorageJson("user-top-bar-color", transparent),
        set: storage.setLocalStorageJson("user-top-bar-color"),
    },
    {
        name: "navBackgroundColor",
        get: storage.getLocalStorageJson("user-nav-background-color", transparent),
        set: storage.setLocalStorageJson("user-nav-background-color"),
    },
    {
        name: "appBackgroundColor",
        get: storage.getLocalStorageJson("user-app-background-color", transparent),
        set: storage.setLocalStorageJson("user-app-background-color"),
    },
    {
        name: "contentBackgroundColor",
        get: storage.getLocalStorageJson("user-content-background-color", transparent),
        set: storage.setLocalStorageJson("user-content-background-color"),
    },
    {
        name: "backgroundImage",
        get: storage.getLocalStorage("user-background-img", "Night Work"),
        set: storage.setLocalStorage("user-background-img"),
    },
    {
        name: "pinnedApps",
        get: storage.getLocalStorageJson("user-pinned-apps", []),
        set: storage.setLocalStorageJson("user-pinned-apps"),
    },
    {
        name: "navPinnedOpen",
        get: storage.getLocalStorageBoolean("user-nav-pinned-open", false),
        set: storage.setLocalStorage("user-nav-pinned-open"),
    },
    {
        name: "customThemes",
        get: storage.getLocalStorageJson("user-custom-themes", { }),
        set: storage.setLocalStorageJson("user-custom-themes"),
    },
    {
        name: "currentTheme",
        get: storage.getLocalStorage("user-current-theme", null),
        set: storage.setLocalStorage("user-current-theme"),
    },

];
